module.exports = __webpack_public_path__ + "img/Book_flight_with_flyiisi.74e0af00.gif";